export default "/Frontend/dist/image-black.059543a36ff6f2a242eab8f44b739cdf.svg";